import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { GoogleAddressGeocoderComponent } from './components';
import { SnGoogleGeocoderService } from './services';

@NgModule({
  imports: [CommonModule],
  exports: [GoogleAddressGeocoderComponent],
  declarations: [GoogleAddressGeocoderComponent],
})
export class SnGoogleGeocoderModule {
  public static forRoot(): ModuleWithProviders<SnGoogleGeocoderModule> {
    return {
      ngModule: SnGoogleGeocoderModule,
      providers: [SnGoogleGeocoderService],
    };
  }
}
